import { Card, CardProps } from '@insight-health-ai/roseate/components';
import { useScreenSize } from '@insight-health-ai/roseate/utils';
import { Divider } from 'antd';

export type DetailsBarProps = Pick<CardProps, 'title' | 'actions'> & {
  details: {
    title: string;
    content: React.ReactNode;
    fallback: React.ReactNode;
    icon?: React.ReactNode;
    style?: React.CSSProperties;
    fallbackStyle?: React.CSSProperties;
  }[][];
};

export const DetailsBar = ({ details, title, actions }: DetailsBarProps) => {
  const detailsMatrix = Array.isArray(details[0])
    ? details
    : ([details] as unknown as DetailsBarProps['details']);

  const { mediaMin } = useScreenSize();

  const jsx = (
    <div className="flex items-center overflow-x-auto overflow-y-hidden gap-4 h-full flex-wrap">
      {detailsMatrix.reduce((acc, row, rowIndex) => {
        if (acc.length && row.length && mediaMin('sm')) {
          acc.push(<Divider className="h-[38px]" type="vertical" />);
        }
        acc = acc.concat(
          row.map(
            (
              { title, content, icon, fallback, style, fallbackStyle },
              index
            ) => {
              return (
                <div
                  key={`${rowIndex}-${index}`}
                  className="flex items-center gap-2 text-nowrap"
                >
                  {icon && <div className="text-gray-500">{icon}</div>}
                  <div className="flex flex-col items-start gap-0.5">
                    <div className="uppercase text-xs text-gray-500">
                      {title}
                    </div>
                    {content ? (
                      <div
                        className="text-sm font-medium"
                        style={{
                          ...style,
                        }}
                      >
                        {content}
                      </div>
                    ) : (
                      <div
                        className="text-sm font-medium text-gray-500 italic"
                        style={{
                          ...(fallbackStyle || style),
                        }}
                      >
                        {fallback}
                      </div>
                    )}
                  </div>
                </div>
              );
            }
          )
        );
        return acc;
      }, [] as React.ReactNode[])}
    </div>
  );

  return (
    <Card title={title} actions={actions} outlined={false} padding={'sm'}>
      {jsx}
    </Card>
  );
};
